export default function replaceState(state: {} | null, title: string, url?: string) {
    if (history.replaceState) {
        history.replaceState(state, title, url);
    }
}
